import { Field } from '@hb/shared'
import { useMemo } from 'react'

export const useInputPlaceholder = (field: Field) => {
  const { placeholder, optional } = field
  return useMemo(
    () => (optional ? `${placeholder} (optional)` : placeholder),
    [placeholder, optional],
  )
}
